export default {
    'widgets.swap-form.header.swap': 'Échanger',
    'widgets.swap-form.input.title.you_pay': 'Vous payez',
    'widgets.swap-form.input.title.you_receive': 'Vous recevez',
    'widgets.swap-form.input.balance.balance': 'Solde',
    'widgets.swap-form.fusion-info.slippage-tolerance': 'Tolérance au glissement',
    'widgets.swap-form.fusion-info.auction-time': "Temps de l'enchère",
    'widgets.swap-form.fusion-info.min-receive': 'Réception minimale',
    'widgets.swap-form.fusion-info.net-fee': 'Frais de réseau',
    'widgets.swap-form.swap-button.confirm-swap': "Confirmer l'échange",
    'widgets.swap-form.swap-button.update-swap-data': "Recherche de chemin d'échange",
    'widgets.swap-form.swap-button.check-allowance': "Vérifier l'allocation",
    'widgets.swap-form.swap-button.native-token-not-supported': "Le jeton natif n'est pas supporté actuellement",
    'widgets.swap-form.swap-button.approve-and-swap': 'Approuver et échanger',
    'widgets.swap-form.swap-button.permit-and-swap': 'Permettre et échanger',
    'widgets.swap-form.swap-button.connect-wallet': 'Connecter le portefeuille',
    'widgets.swap-form.swap-button.select-source-token': 'Sélectionner le jeton source',
    'widgets.swap-form.swap-button.select-destination-token': 'Sélectionner le jeton de destination',
    'widgets.swap-form.swap-button.enter-amount-to-swap': 'Entrez le montant à échanger',
    'widgets.swap-form.swap-button.no-liquidity-for-swap': "Pas de liquidité pour l'échange",
    'widgets.swap-form.swap-button.insufficient-balance': 'Solde insuffisant de {{symbol}}',
    'widgets.swap-form.swap-button.set-max': 'Définir le max {{symbol}}',
    'widgets.swap-form.swap-button.wait-wallet-response': 'Attendre la réponse du portefeuille',
    'widgets.swap-form.swap-button.permit-swap-in-wallet': "Permettre l'échange dans le portefeuille",
    'widgets.swap-form.swap-button.allow-swap-in-wallet': "Autoriser l'échange dans le portefeuille",
    'widgets.swap-form.swap-button.wallet-rejected': 'Le portefeuille a rejeté la demande',
    'widgets.swap-form.swap-button.swap-error-message': "Erreur d'échange",
    'widgets.swap-form.swap-button.waiting-approve-transaction': "En attente de l'approbation du jeton",
};
//# sourceMappingURL=fr.js.map